import React, { useContext, useState } from "react";
import { Card, Radio, Button, Space, Progress, Modal } from "antd";
import './Course.css';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../UserContext";
import LoaderTeacher from "../../Loader/Loader_Teacher";

const Quiz = ({quizdata,module}) => {
	// const { state } = useLocation();
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [loading, setloading] = useState(false);
	const [selectedOptions, setSelectedOptions] = useState(
		Array(quizdata.easy.length + quizdata.medium.length + quizdata.hard.length).fill(
			null
		)
	);
	const { studentapiuri, token } = useContext(UserContext);
	const { courseId } = useParams();
	const [modelopen, setmodelopen] = useState(false);
	const [responsedata, setresponsedata] = useState({});
	const navigate = useNavigate();
	// console.log(state);

	const handleNext = async () => {
		if (currentQuestion < getTotalQuestionsCount() - 1) {
			setCurrentQuestion(currentQuestion + 1);
		} else {
			const resultObject = [];
			// console.log(selectedOptions);
			selectedOptions.forEach((optionIndex, questionIndex) => {
				// console.log(questionIndex);
				const questionData = getCurrentQuestionData(questionIndex);
				// console.log(questionData);
				if (questionData) {
					const difficultyLevel = getDifficultyLevel(questionData);
					if (difficultyLevel === "medium") {
						questionIndex = questionIndex - 8;
					}
					if (difficultyLevel === "hard") {
						questionIndex = questionIndex - 14;
					}
					// console.log(state[difficultyLevel][questionIndex]?._id);
					resultObject.push({
						difficulty: difficultyLevel,
						option: optionIndex.toString(),
						_id: quizdata[difficultyLevel][questionIndex]._id,
					});
				}
			});

			// console.log(resultObject);

			await handlefinalsubmit(resultObject);
		}
	};

	const handlefinalsubmit = async (result) => {
		setloading(true);
		const response = await fetch(`${studentapiuri}/stud/submitqt/${courseId}/${module}`, {
			method: "POST",
			headers: {
				"content-type": "application/json",
				Authorization: "BEARER " + token,
			},
			body: JSON.stringify({ qt: result }),
		});
		console.log(response);
		const data = await response.json();
		console.log(data);
		setresponsedata(data.data);
		setloading(false);
		setmodelopen(true);
	};

	const handlePrev = () => {
		setCurrentQuestion(currentQuestion - 1);
	};

	const handleOptionChange = (e) => {
		const updatedOptions = [...selectedOptions];
		updatedOptions[currentQuestion] = e.target.value;
		setSelectedOptions(updatedOptions);
	};

	const getCurrentQuestionData = (questionIndex) => {
		if (questionIndex < quizdata.easy.length) {
			return quizdata.easy[questionIndex];
		} else if (questionIndex < quizdata.easy.length + quizdata.medium.length) {
			return quizdata.medium[questionIndex - quizdata.easy.length];
		} else {
			return quizdata.hard[
				questionIndex - quizdata.easy.length - quizdata.medium.length
			];
		}
	};

	const getDifficultyLevel = (questionData) => {
		if (quizdata.easy.includes(questionData)) {
			return "easy";
		} else if (quizdata.medium.includes(questionData)) {
			return "medium";
		} else if (quizdata.hard.includes(questionData)) {
			return "hard";
		}
	};
	// console.log(getDifficultyLevel(9))
	const getTotalQuestionsCount = () => {
		return quizdata.easy.length + quizdata.medium.length + quizdata.hard.length;
	};

	const currentQuestionData = getCurrentQuestionData(currentQuestion);

	if (loading) {
		return <LoaderTeacher loader_text={"Evaluating Answers"}></LoaderTeacher>;
	}

	const gotocourse = () => {
		navigate(`/student/courses/${courseId}/module/1/submodule/1`);
	};

	return (
		<div className="quiz-container">
			<div className="section-header">{quizdata.quizName}</div>
			<Card
				className="quiz-question-container"
				title={`Question ${currentQuestion + 1}`}>
				<p className="quiz-question">{currentQuestionData.question}</p>
				<Radio.Group
					style={{ display: "flex", flexDirection: "column" }}
					onChange={handleOptionChange}
					value={selectedOptions[currentQuestion]}>
					{currentQuestionData.options.map((option, optionIndex) => (
						<Radio
							key={optionIndex}
							value={optionIndex}
							className="quiz-option">
							{option}
						</Radio>
					))}
				</Radio.Group>
				<div className="buttons-container">
					{currentQuestion !== 0 ? (
						<Button type="primary" onClick={handlePrev}>
							Previous
						</Button>
					) : (
						<></>
					)}

					<Button type="primary" onClick={handleNext}>
						{currentQuestion < getTotalQuestionsCount() - 1 ? "Next" : "Submit"}
					</Button>
				</div>
			</Card>

			<Modal
				title="Knowledge test Analysis"
				open={modelopen}
				onCancel={() => setmodelopen(false)}
				footer=""
				// classNames={classNames}
				// styles={modalStyles}
			>
				<br></br>
				<br></br>
				<Space wrap>
					<div>
						<Progress
							type="circle"
							percent={responsedata?.per_easy}
							format={(percent) => `${percent.toFixed(2)}`}
						/>
						<center>
							<h3>Easy</h3>
						</center>
					</div>
					<div>
						<Progress
							type="circle"
							percent={responsedata?.per_medium}
							status="exception"
							format={(percent) => `${percent.toFixed(2)}`}
						/>
						<center>
							<h3>Medium</h3>
						</center>
					</div>
					<div>
						<Progress
							type="circle"
							percent={responsedata?.per_hard}
							format={(percent) => `${percent.toFixed(2)}`}
						/>
						<center>
							<h3>Hard</h3>
						</center>
					</div>
				</Space>
				<br></br>
				<br></br>
				<center>
					<h4>
						{" "}
						Level -{" "}
						{responsedata?.level === "1"
							? "Easy"
							: responsedata?.level === "2"
							? "Medium"
							: "Hard"}
					</h4>
				</center>
				<Button onClick={gotocourse}>Go to Course</Button>
			</Modal>
		</div>
	);
};

export default Quiz;
